// extracted by mini-css-extract-plugin
export default {"root":"Zdj1EEyAi3"};